import { render, staticRenderFns } from "./selectOrderSubType.vue?vue&type=template&id=794ccc6b"
import script from "./selectOrderSubType.vue?vue&type=script&lang=js"
export * from "./selectOrderSubType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports